import React, {useEffect, useRef, useState} from 'react';

import {getTimeValFromMillisecond, TimeVal} from '../../utils';

interface CooldownTimerProps {
  className?: string
  time: number //time in milliSecond
  cooldownTo: number //time in milliSecond
  tickDuration?: number

  timeFormatter(timeVal: TimeVal): string
}


const CooldownTimer = (
  {
    className,
    time,
    cooldownTo,
    tickDuration = 1000,
    timeFormatter
  }: CooldownTimerProps) => {

  const [currentTime, setCurrentTime] = useState<number>(cooldownTo);
  const intervalRef = useRef<number>();

  useEffect(() => {
    setCurrentTime(cooldownTo);
  }, [cooldownTo]);

  useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      const increaseTime = currentTime + tickDuration;

      if (time - increaseTime <= 0) {
        window.clearInterval(intervalRef.current);
      }

      setCurrentTime(curTime => increaseTime);
    }, tickDuration);

    return () => {
      window.clearInterval(intervalRef.current);
    }
  }, [time, cooldownTo, tickDuration, currentTime]);

  const timeVal = getTimeValFromMillisecond(time - currentTime <= 0 ? 0 : time - currentTime);

  return (
    <div className={className}>
      {timeFormatter(timeVal)}
    </div>
  );
};


export default CooldownTimer;
